import { IsArray } from "class-validator";
import { Type } from "class-transformer";
import { LessonModel } from "./model";

export class LessonCollectionResultDto {
	@Type(() => LessonModel)
	@IsArray()
	items: LessonModel[] = [];
}
